var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('form', {
    ref: "form",
    attrs: {
      "name": "form_auth",
      "method": "post",
      "action": _vm.callUrl
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "reg_cert_key"
    },
    domProps: {
      "value": _vm.regCertKey
    }
  }), _c('iframe', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "kcp_cert",
      "name": "kcp_cert",
      "width": "100%",
      "height": "700",
      "frameborder": "0",
      "scrolling": "no"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }